<template>
    <div id="uploadAsnDetail">
        <a-modal
                :title="$t('publicLang.Upload')"
                :visible="uploadAsnDetailVis"
                :maskClosable="false"
                :keyboard="false"
                centered
                @cancel="cancel">
            <template slot="footer">
                <a-row type="flex" justify="center">
                    <a-col>
                        <a-button class="marginButton" type="primary" size="small" :loading="uploading" @click="update">{{ $t('publicLang.Upload') }}</a-button>
                    </a-col>
                    <a-col>
                        <a-button class="marginButton" type="primary" size="small" @click="cancel">{{ $t('publicLang.Cancel') }}</a-button>
                    </a-col>
                </a-row>
            </template>
            <a-form :form="fileUploadForm">
                <a-row type="flex" class="buttonLine">
                    <a-col>
                        <a-upload
                                :loading="uploading"
                                :multiple="false"
                                :showUploadList="false"
                                :file-list="fileList"
                                :before-upload="uploadFile"
                                accept=".xls,.xlsx">
                            <a-button class="button" size="small">{{ $t('publicLang.Upload') }}</a-button>
                        </a-upload>
                    </a-col>
                    <a-col>
                        <a-button class="button" size="small" @click="uploadFileDel">{{ $t('generic.Delete') }}</a-button>
                    </a-col>
                </a-row>
                <hr class="divider">
                <a-table
                        class="table"
                        :columns="UploadFIleFormColumns"
                        :dataSource="uploadFileFormList"
                        size="small"
                        :pagination="nopagination"
                        :locale="tabelText"
                        :scroll="{ y: 300 }"
                        :rowClassName="rowClassName"
                        :customRow="customRow"
                />
            </a-form>
        </a-modal>
    </div>
</template>

<script>
    import ajax from '../../../api/ajax';
    import api from '../../../api/url';

    export default {
        data() {
            return {
                uploadAsnDetailVis: false,
                fileUploadForm: this.$form.createForm(this),
                tabelText: {
                    emptyText: this.$t('publicLang.PleaseFirst')
                },
                UploadFIleFormColumns: [
                    {
                        title: this.$t('publicLang.FileName'),
                        dataIndex: "fileName"
                    }
                ],
                nopagination: false,
                fileList: [],
                uploadFileFormList: [],
                selectedRowKey: null,
                uploading: false,
            };
        },
        methods: {
            show() {
                this.uploadAsnDetailVis = true;
            },
            customRow(record) {
                return {
                    on: {
                        click: () => {
                            if (this.selectedRowKey === record.key) {
                                this.selectedRowKey = null;
                            } else {
                                this.selectedRowKey = record.key;
                            }
                        }
                    }
                };
            },
            rowClassName(record) {
                return record.key === this.selectedRowKey ? 'selected-row' : '';
            },
            uploadFile(file) {
                this.fileList = [file];
                this.uploadFileFormList = [{ key: file.uid, fileName: file.name, size: file.size, type: file.type }];
                return false;
            },
            update() {
                if (this.fileList.length === 0) {
                    this.$customMessage.warning(this.$t("publicLang.PleaseFirst"));
                    return;
                }
                let file = this.fileList[0];
                if (file.size > 2097152) {
                    this.$customMessage.warning(this.$t('publicLang.UploadFileOverSize') + '\n' + file.name, 3);
                    return;
                }
                let formData = new FormData();
                formData.append('file', file);
                this.uploading = true;
                ajax.post(api.UPLOADASNDETAIL, formData).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        this.$emit('success');
                        this.cancel();
                    } else {
                        this.$customMessage.warning(res.msg);
                    }
                    this.uploadFileDel();
                }).catch(err => {
                    this.$customMessage.error(err.message);
                }).finally(() => {
                    this.uploading = false;
                });
            },
            uploadFileDel() {
                this.fileList = [];
                this.uploadFileFormList = [];
                this.selectedRowKey = null;
            },
            cancel() {
                this.fileList = [];
                this.uploadFileFormList = [];
                this.uploadAsnDetailVis = false;
                this.selectedRowKey = null;
            }
        }
    };
</script>

<style>
.divider {
    width: 100%;
    height: 2px;
    background-color: rgb(232, 232, 232);
    border: none;
    margin: 0px;
    margin-top: 3px;
    margin-bottom: 3px;
}
.buttonLine {
    height: 25px;
}
.button {
    align-items: flex-start;
    margin-right: 8px;
}
.marginButton {
    margin-right: 20px;
}
.selected-row {
    background-color: #e6f7ff;
}
</style>
